/**
 * 题库题目
 */

import {
    get,
    post,
    put,
    del
} from '@/util/request'

/**
 * 根据Id查询
 * @param {*} Id
 * @returns
 */
export const SelectQuestionBankListById = (Id) => {
    return get('/api/app/QuestionBankList?CurrentId=' + Id);
}

/**
 * 1.通过题库id获取题目及题目选项信息
 * @param {*} Id
 * @returns
 */
export const SelectByQuestionBankId = (Id) => {
    return get('/api/app/questionBankList/'+Id+'/byQuestionBankId');
}

/**
 * 新增数据记录
 * @param {*} data
 * @returns
 */
export const AddQuestionBankList = (data) => {
    return post('/api/app/QuestionBankList', data, {});
}

/**
 * 更新数据记录
 * @param {*} data
 * @returns
 */
export const ModifyQuestionBankList = (data) => {
    return put('/api/app/QuestionBankList', data, {});
}

/**
 * 分页获取
 * @param {*} data
 * @returns
 */
export const GetDataQuestionBankListList = (data) => {
    return post('/api/app/QuestionBankList/list', data, {});
}


/**
 * 链表分页获取
 * @param {*} data
 * @returns
 */
export const GetDataQuestionBankListListByPageQuery = (data) => {
    return post('/api/app/QuestionBankList/getDataByPageQuery', data, {});
}

/**
 * 删除记录
 * @param {*} id
 * @returns
 */
export const DeleteQuestionBankList = (id) => {
    return del('/api/app/QuestionBankList/' + id, {}, {});
}

  /**
   * 1.通过题库id获取题目及题目选项信息
   * @param {*} id
   * @returns
   */
   export const GetQuestionBankListById = (id) => {
    return post('/api/app/questionBankList/getQuestionBankListById/'+id);
  }

  /**
   * 2.题库题目编辑
   * @param {*} id
   * @returns
   */
  export const EditQuestionBankList = (id,data) => {
    return post('api/app/questionBankList/editQuestionBankList/'+id,data);
  }

  export const deleteQuestionTopic = (id,data) => {
    return post('api/app/questionBankList/deleteQuestionTopic/'+id,data);
  }